var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warning_Symbol",
    "data-name": "Warning Symbol",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.189,
    height: 30.189,
    viewBox: "0 0 30.189 30.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25643",
    "data-name": "Group 25643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25642",
    "data-name": "Group 25642"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 15.095,
    cy: 15.095,
    r: 15.095,
    fill: "#c00"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_25732",
    "data-name": "Group 25732",
    transform: "translate(-22.135 -92.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25732-2",
    "data-name": "Group 25732",
    transform: "translate(35.233 98.78)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37104",
    "data-name": "Path 37104",
    d: "M169.548,608.973a2,2,0,1,0,2,2A2,2,0,0,0,169.548,608.973Z",
    transform: "translate(-167.554 -596.239)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37105",
    "data-name": "Path 37105",
    d: "M169.552,595.073a1.946,1.946,0,0,0-1.545.581,1.632,1.632,0,0,0-.374,1.261l1.234,8.386c.026.484.243.71.684.71a.711.711,0,0,0,.69-.731l0-.027,1.231-8.335a1.659,1.659,0,0,0-.375-1.262A1.946,1.946,0,0,0,169.552,595.073Z",
    transform: "translate(-167.56 -595.067)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.f8ab1b742d275966d9367cd95643e940.svg";
export { ForwardRef as ReactComponent };